import DOMPurify from 'dompurify';

// أمان: فرض rel="noopener noreferrer" على أي رابط يفتح في تبويب جديد (target)
// لمنع reverse-tabnabbing — الرابط الجديد لا يقدر يتحكّم بصفحتنا عبر window.opener.
// يُسجَّل مرة واحدة عند تحميل الوحدة.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.hasAttribute('target')) {
    node.setAttribute('rel', 'noopener noreferrer');
    node.setAttribute('target', '_blank');
  }
});

/**
 * تنقية محتوى HTML قادم من الخادم (صفحات المحتوى CMS) قبل حقنه في DOM.
 * يمنع هجمات XSS المخزّنة عبر السماح فقط بوسوم التنسيق الآمنة ومنع
 * السكربتات ومعالجات الأحداث وروابط javascript:.
 */
export function sanitizeHtml(dirty: string | null | undefined): string {
  if (!dirty) return '';
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: [
      'p', 'br', 'b', 'strong', 'i', 'em', 'u', 'span', 'div',
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      'ul', 'ol', 'li', 'blockquote', 'hr',
      'a', 'table', 'thead', 'tbody', 'tr', 'th', 'td',
    ],
    ALLOWED_ATTR: ['href', 'title', 'target', 'rel', 'style', 'dir', 'class'],
    // منع أي رابط بغير http/https/mailto/tel
    ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))/i,
  });
}
